export default __webpack_public_path__ + "static/media/Forge_HTB.6dac08f3.md";